import { createSelector } from 'reselect';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { TInitialState } from '~/src/components/ConnectDomruPopup/context/initialState';

export const selectResultMessage = createSelector(
    [
        (state: TInitialState) => state.result,
    ],
    ({ status, message }) => {
        if (status === EResultPopupStatus.ERROR) {
            return {
                title: 'Ваша заявка не отправилась',
                text: 'Это какая-то ошибка. Пожалуйста, попробуйте еще раз или напишите нам в чат.',
            };
        }

        const [title, text] = message.split('.');

        return { title, text };
    },
);
